import * as C from '../constants';
import * as ActionCreators from '../actions/ActionCreators';
import { actionEqual } from './utils';

const defaultState: FreeTrialState = {
  state: C.STATE.FREE_TRIAL.DEFAULT,
  isStartFreeTrial: false,
};

export default function freeTrial(
  state: FreeTrialState = defaultState,
  action: Action
): FreeTrialState {
  if (actionEqual(action, ActionCreators.actionUpdateFreeTrialState)) {
    return {
      ...state,
      state: action.payload.state,
    };
  } else if (actionEqual(action, ActionCreators.actionUpdateIsStartFreeTrial)) {
    return {
      ...state,
      isStartFreeTrial: action.payload.isStart,
    };
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/freeTrial.ts